import moment from "moment-timezone";
import { useEffect, useState } from "react";

const useRemainingTimeForBank = (actionedAt, publisheddAt) => {
  const [remainingTime, setRemainingTime] = useState("");

  // console.log("actionedAt", actionedAt);
  // console.log("publisheddAt", publisheddAt);

  useEffect(() => {
    const actionedTime = moment.tz(
      actionedAt,
      "DD/MM/YYYY HH:mm",
      "Europe/London",
    );
    const publishedTime = moment.tz(
      publisheddAt,
      "DD/MM/YYYY HH:mm",
      "Europe/London",
    );

    const expirationTime = publishedTime;

    const updateRemainingTime = () => {
      const now = moment.tz("Europe/London");
      const diff = expirationTime.diff(now);

      if (diff > 0) {
        const duration = moment.duration(diff);
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        let remainingTime = "";

        if (days > 0) remainingTime += `${days} day${days > 1 ? "s" : ""} `;
        if (hours > 0 || days > 0)
          remainingTime += `${hours} hour${hours > 1 ? "s" : ""} `;
        if (minutes > 0 || hours > 0 || days > 0)
          remainingTime += `${minutes} minute${minutes > 1 ? "s" : ""}`;

        // If no hours and minutes left, show seconds
        if (days === 0 && hours === 0 && minutes === 0) {
          remainingTime += `${seconds} second${seconds > 1 ? "s" : ""}`;
        }

        setRemainingTime(remainingTime);
      } else {
        setRemainingTime("Expired");
      }
    };

    updateRemainingTime();
    const intervalId = setInterval(updateRemainingTime, 1000);

    return () => clearInterval(intervalId);
  }, [actionedAt, publisheddAt]);

  return remainingTime;
};

export default useRemainingTimeForBank;
